/* ============================================================
   Modulo Logo Cloud
   Infinite Autoplay + Desktop Mouse Drag + Mobile Touch Swipe
   ============================================================ */

(function () {
  'use strict';

  if (typeof window === 'undefined') return;

  function getGap(el) {
    var style = getComputedStyle(el);
    var raw = style.columnGap || style.gap || '0';
    var n = parseFloat(raw);
    return isNaN(n) ? 0 : n;
  }

  function measureCycle(originals, gap) {
    var width = 0;

    for (var i = 0; i < originals.length; i++) {
      width += originals[i].getBoundingClientRect().width;
    }

    return width + gap * originals.length;
  }

  function cloneSet(track, originals) {
    for (var i = 0; i < originals.length; i++) {
      var clone = originals[i].cloneNode(true);

      clone.setAttribute('aria-hidden', 'true');
      clone.removeAttribute('role');
      clone.setAttribute('data-modulo-lc-clone', '1');

      track.appendChild(clone);
    }
  }

  function initLogocloud(el) {
    if (el.dataset.moduloDragReady === '1') return;

    var track = el.querySelector('.modulo-lc__track');
    if (!track) return;

    var originals = Array.prototype.slice.call(track.children);
    if (!originals.length) return;

    for (var i = 0; i < originals.length; i++) {
      originals[i].setAttribute('data-modulo-lc-original', '1');
    }

    var gap = getGap(track);
    var cycleWidth = measureCycle(originals, gap);

    if (cycleWidth <= 0) return;

    var viewportWidth =
      el.offsetWidth ||
      document.documentElement.clientWidth;

    var requiredWidth =
      viewportWidth +
      cycleWidth * 2;

    while (track.scrollWidth < requiredWidth) {
      cloneSet(track, originals);
    }

    /* Alte CSS-Animation deaktivieren */
    track.style.animation = 'none';
    track.style.webkitAnimation = 'none';

    track.style.willChange = 'transform';

    /* Drag-Verhalten */
    el.style.cursor = 'grab';
    el.style.touchAction = 'pan-y';
    el.style.userSelect = 'none';
    el.style.webkitUserSelect = 'none';
    el.style.webkitUserDrag = 'none';
    el.style.webkitTouchCallout = 'none';

    /* Bilder nicht separat ziehen lassen */
    var images = track.querySelectorAll('img');

    for (var imgIndex = 0; imgIndex < images.length; imgIndex++) {
      images[imgIndex].setAttribute('draggable', 'false');
      images[imgIndex].style.pointerEvents = 'none';
      images[imgIndex].style.userSelect = 'none';
      images[imgIndex].style.webkitUserDrag = 'none';
    }

    /* Links ebenfalls nicht native ziehen lassen */
    var links = track.querySelectorAll('a');

    for (var linkIndex = 0; linkIndex < links.length; linkIndex++) {
      links[linkIndex].setAttribute('draggable', 'false');
    }

    /* Richtung aus deinen Shopify-Einstellungen */
    var section = el.closest('.modulo-lc');

    var direction = -1;

    if (
      section &&
      section.classList.contains('modulo-lc--dir-right')
    ) {
      direction = 1;
    }

    /* RTL-Unterstützung */
    var pageDirection =
      getComputedStyle(document.documentElement).direction;

    if (pageDirection === 'rtl') {
      direction *= -1;
    }

    /* Geschwindigkeit aus Shopify übernehmen */
    var durationRaw = section
      ? getComputedStyle(section)
          .getPropertyValue('--modulo-lc-speed')
          .trim()
      : '30s';

    var duration = parseFloat(durationRaw);

    if (!duration || duration <= 0) {
      duration = 30;
    }

    var pixelsPerSecond = cycleWidth / duration;

    /* Startposition */
    var position = direction === 1
      ? -cycleWidth
      : 0;

    function normalizePosition() {
      while (position <= -cycleWidth) {
        position += cycleWidth;
      }

      while (position > 0) {
        position -= cycleWidth;
      }
    }

    function render() {
      track.style.transform =
        'translate3d(' + position + 'px, 0, 0)';
    }

    render();

    /* Autoplay */
    var dragging = false;
    var paused = false;
    var lastTime = performance.now();

    function animate(now) {
      var delta =
        Math.min((now - lastTime) / 1000, 0.05);

      lastTime = now;

      if (!dragging && !paused) {
        position +=
          pixelsPerSecond *
          delta *
          direction;

        normalizePosition();
        render();
      }

      requestAnimationFrame(animate);
    }

    requestAnimationFrame(animate);

    /* Drag / Touch */
    var startX = 0;
    var startPosition = 0;

    var moved = false;
    var pointerId = null;

    function pointerDown(event) {
      if (
        event.pointerType === 'mouse' &&
        event.button !== 0
      ) {
        return;
      }

      dragging = true;
      moved = false;
      paused = true;

      pointerId = event.pointerId;

      startX = event.clientX;
      startPosition = position;

      el.style.cursor = 'grabbing';

      if (event.pointerType === 'mouse') {
        event.preventDefault();
      }

      try {
        el.setPointerCapture(pointerId);
      } catch (e) {}
    }

    function pointerMove(event) {
      if (!dragging) return;

      if (event.pointerType === 'mouse') {
        event.preventDefault();
      }

      var difference =
        event.clientX - startX;

      if (Math.abs(difference) > 3) {
        moved = true;
      }

      /*
        Desktop etwas schneller reagieren lassen.
        Wenn es dir noch zu langsam ist:
        1.6 auf 2 oder 2.5 erhöhen.
      */
      var dragSpeed =
        event.pointerType === 'mouse'
          ? 1.6
          : 1;

      position =
        startPosition +
        difference * dragSpeed;

      normalizePosition();
      render();
    }

    function pointerUp(event) {
      if (!dragging) return;

      dragging = false;

      el.style.cursor = 'grab';

      try {
        el.releasePointerCapture(pointerId);
      } catch (e) {}

      pointerId = null;

      /*
        Autoplay nach kurzer Pause fortsetzen.
      */
      setTimeout(function () {
        paused = false;
      }, 600);
    }

    el.addEventListener(
      'pointerdown',
      pointerDown
    );

    el.addEventListener(
      'pointermove',
      pointerMove
    );

    el.addEventListener(
      'pointerup',
      pointerUp
    );

    el.addEventListener(
      'pointercancel',
      pointerUp
    );

    el.addEventListener(
      'lostpointercapture',
      function () {
        if (dragging) {
          dragging = false;

          el.style.cursor = 'grab';

          setTimeout(function () {
            paused = false;
          }, 600);
        }
      }
    );

    /* Verhindert Klick auf Sponsor-Link nach einem Drag */
    el.addEventListener(
      'click',
      function (event) {
        if (moved) {
          event.preventDefault();
          event.stopPropagation();
          moved = false;
        }
      },
      true
    );

    /* Browser-eigenes Draggen verhindern */
    el.addEventListener(
      'dragstart',
      function (event) {
        event.preventDefault();
      }
    );

    /* Pause on Hover aus Shopify */
    if (
      section &&
      section.classList.contains(
        'modulo-lc--pausable'
      )
    ) {
      el.addEventListener(
        'mouseenter',
        function () {
          if (!dragging) {
            paused = true;
          }
        }
      );

      el.addEventListener(
        'mouseleave',
        function () {
          if (!dragging) {
            paused = false;
          }
        }
      );
    }

    /* Resize */
    var resizeTimer = null;

    window.addEventListener(
      'resize',
      function () {
        clearTimeout(resizeTimer);

        resizeTimer = setTimeout(
          function () {
            var newViewport =
              el.offsetWidth ||
              document.documentElement.clientWidth;

            var needed =
              newViewport +
              cycleWidth * 2;

            while (
              track.scrollWidth < needed
            ) {
              cloneSet(track, originals);
            }
          },
          150
        );
      }
    );

    el.dataset.moduloDragReady = '1';
  }

  function bootstrap(root) {
    root = root || document;

    var elements =
      root.querySelectorAll(
        '[data-modulo-logocloud]'
      );

    for (
      var i = 0;
      i < elements.length;
      i++
    ) {
      initLogocloud(elements[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      function () {
        bootstrap(document);
      }
    );
  } else {
    bootstrap(document);
  }

  /* Shopify Theme Editor */
  document.addEventListener(
    'shopify:section:load',
    function (event) {
      bootstrap(event.target);
    }
  );
})();